import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M25.5629 4.14368L5.10295 12.9754C3.74295 13.5149 3.60295 15.3732 4.84295 16.1325L10.8229 19.7491L18.2829 12.2961C18.6829 11.8964 19.3029 11.8964 19.7029 12.2961C20.1029 12.6957 20.1029 13.3151 19.7029 13.7147L12.2429 21.1678L15.8629 27.1422C16.6229 28.3811 18.4629 28.2412 19.0229 26.8825L27.8629 6.42155C28.4429 4.9829 27.0029 3.54424 25.5629 4.1237V4.14368Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }